<template>
    <div>
        <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess || isFailed">
            <div class="dropbox">
                <input type="file"
                       :name="uploadFieldName"
                       :disabled="isSaving"
                       @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                       :accept="acceptType"
                       class="input-file">
                <p v-if="isInitial" v-html="this.dropBoxInitialText">
                    {{ this.dropBoxInitialText }}
                </p>
                <p v-if="isSaving">
                    Uploading {{ fileCount }} file{{ fileCount > 1 ? 's' : '' }}...
                </p>
                <p v-if="isSuccess" class="text-success">
                    <span v-html="successMessage ? successMessage : `Uploaded ${fileCount} file ${fileCount > 1 ? 's' : ''}`"></span>
                </p>
                <p v-if="isFailed">
                    <span class="errmsg">Your upload process has failed</span>
                </p>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from 'axios'
    import get from 'lodash/get'
    import dialog from './dialog'

    const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3

    export default {
        name:  'file-upload',
        props: {
            title:              {
                type:    String,
                default: 'File Upload'
            },
            uploadFieldName:    {
                type:    String,
                default: 'file'
            },
            uploadUrl:          {
                type:    String,
                default: ''
            },
            acceptType:         {
                type:    String,
                default: '*/*'
            },
            dropBoxInitialText: {
                type:    String,
                default: 'Drag your file(s) here <br/> or click to browse'
            }
        },

        data() {
            return {
                uploadError:    null,
                currentStatus:  null,
                successMessage: null,
            }
        },

        computed: {
            isInitial() {
                return this.currentStatus === STATUS_INITIAL
            },

            isSaving() {
                return this.currentStatus === STATUS_SAVING
            },

            isSuccess() {
                return this.currentStatus === STATUS_SUCCESS
            },

            isFailed() {
                return this.currentStatus === STATUS_FAILED
            }
        },
        methods:  {
            reset() {
                // reset form to initial state
                this.currentStatus = STATUS_INITIAL
                this.uploadError = null
            },

            filesChange(fieldName, fileList) {
                const formData = new FormData()

                if (!fileList.length) return

                // append the files to FormData
                Array
                    .from(Array(fileList.length).keys())
                    .map(x => {
                        formData.append(fieldName, fileList[x], fileList[x].name)
                    })

                // save it
                this.save(formData)
            },

            save(formData) {
                // upload data to the server
                this.currentStatus = STATUS_SAVING

                this.uploadFile(formData, this.uploadFieldName)
                    .then(response => {
                        this.currentStatus = STATUS_SUCCESS
                        this.successMessage = get(response, 'data.message')
                    })
                    .catch(err => {
                        dialog.error(err)
                        this.currentStatus = STATUS_FAILED
                    })
            },

            uploadFile(formData) {
                return axios.post(this.uploadUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            }
        },

        mounted() {
            this.reset()
        },
    }
</script>

<style>
    .dropbox {
        outline: 1px dashed grey;
        outline-offset: -10px;
        background: #e5e5e5;
        color: dimgray;
        padding: 10px 10px;
        min-height: 160px;
        position: relative;
        cursor: pointer;
    }

    .input-file {
        opacity: 0;
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    .dropbox:hover {
        background: lightblue;
    }

    .dropbox p {
        font-size: 1.2em;
        text-align: center;
        padding: 50px 0;
    }

    .errmsg {
        color: red;
    }

</style>
